import _ from 'lodash';
import _renameKeys from '../../lib/snowjs/lodash-mixins/rename-keys';
import { BaseModel } from '../lib';


export default class TheaterModel extends BaseModel {

  get numScreensIntValue() {
    return this._convertToInteger(this.num_screens);
  }
  set numScreensIntValue(value) {
    this.num_screens = this._convertIntegerToIntegerString(value);
  }

  get closedForSeasonBooleanValue() {
    return this._convertToBoolean(this.closed_for_season);
  }
  set closedForSeasonBooleanValue(value) {
    this.closed_for_season = this._convertBooleanToBooleanString(value);
  }

  get supports3DBooleanValue() {
    return this._convertToBoolean(this.supports3D);
  }
  set supports3DBooleanValue(value) {
    this.supports3D = this._convertBooleanToBooleanString(value);
  }

  get supportsDigitalBooleanValue() {
    return this._convertToBoolean(this.supportsDigital);
  }
  set supportsDigitalBooleanValue(value) {
    this.supportsDigital = this._convertBooleanToBooleanString(value);
  }

  get supportsDigital4KBooleanValue() {
    return this._convertToBoolean(this.supportsDigital4K);
  }
  set supportsDigital4KBooleanValue(value) {
    this.supportsDigital4K = this._convertBooleanToBooleanString(value);
  }

  get sortIndexIntValue() {
    return _.parseInt(this.sort_index);
  }
  set sortIndexIntValue(value) {
    this.sort_index = _.toString(value);
  }

  toPublishedData() {
    let intKeys = 'id sort_index num_screens'.split(' ');
    let boolKeys = 'supports3D supportsDigital supportsDigital4K closed_for_season'.split(' ');
    let obj = _.toPlainObject(this);
    _.each(intKeys, k => {
      _.set(obj, k, _.parseInt(_.get(obj, k)));
    });
    _.each(boolKeys, k => {
      _.set(obj, k, this._convertToBoolean(_.get(obj, k)));
    });
    obj.anchor = obj.nickname;
    obj.screens = _.map(obj.screens, screen => {
      screen.screenNumber = screen.id;
      return  screen;
    });
    delete obj.manager_notes;
    _renameKeys(obj, { comments: 'comment', closed_for_season: 'closedForSeason', sort_index: 'sortIndex', num_screens: 'numScreens' });

    return obj;
  }

}
